"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKResponsiveNav = void 0;
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// @TODO: fix jsx-a11y
var React = __importStar(require("react"));
var reactstrap_1 = require("reactstrap");
var components_1 = require("../../../components");
var models_1 = require("../../../models");
var hooks_1 = require("../../../common/hooks");
var GKResponsiveNav_helpers_1 = require("./GKResponsiveNav.helpers");
require("./GKResponsiveNav.css");
/**
 * @deprecated in favor of GKMainNav within GKLayoutShell.
 *
 * Navbar with a responsive navigation menu.
 *
 * @remarks
 * Nav items will render horizontally following the GranularLogo on desktop/tablet
 * and drop into an off-canvas menu on mobile (beneath the logo). The component optionally
 * supports react-router >=4.0, depending on what is passed to the navItems props. The icon
 * can also be configured to link to a router path or static url.
 */
var GKResponsiveNav = function (props) {
    var _a = (0, hooks_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-responsive-nav",
        className: "gk-navbar px-3",
    }), children = _a.children, home = _a.home, _b = _a.navItems, navItems = _b === void 0 ? [] : _b, otherProps = __rest(_a, ["children", "home", "navItems"]);
    var _c = React.useState(false), offCanvasOpen = _c[0], setOffCanvasOpen = _c[1];
    var isMobileSized = (0, hooks_1.useDeviceSizes)().isMobileSized;
    var hasItems = navItems.length > 0;
    var toggle = function () { return setOffCanvasOpen(!offCanvasOpen); };
    var getNav = function (orientation) { return (React.createElement(components_1.GKNav, { orientation: orientation, onClick: toggle },
        React.createElement(React.Suspense, { fallback: null }, (0, GKResponsiveNav_helpers_1.getNavItemElements)(navItems)))); };
    return (React.createElement(React.Fragment, null,
        React.createElement(reactstrap_1.Navbar, __assign({}, otherProps),
            hasItems ? (React.createElement(React.Fragment, null,
                isMobileSized && (React.createElement(components_1.GKButton, { color: "link", icon: components_1.GKIconName.Menu, onClick: toggle, size: "lg" })),
                !isMobileSized && (React.createElement(React.Fragment, null,
                    React.createElement(GKResponsiveNav_helpers_1.HomeLink, { isInNavbar: true, home: home },
                        React.createElement(components_1.GKGranularLogo, null)),
                    React.createElement("div", { className: "gk-navbar-left ml-3 mr-auto" }, getNav(models_1.Orientation.Horizontal)))))) : (React.createElement(GKResponsiveNav_helpers_1.HomeLink, { isInNavbar: true, home: home },
                React.createElement(components_1.GKGranularLogo, null))),
            children),
        hasItems && isMobileSized && (React.createElement("div", null,
            React.createElement("div", { className: "off-canvas-overlay " + (offCanvasOpen ? "open" : ""), onClick: toggle }),
            React.createElement("div", { className: "off-canvas-menu " + (offCanvasOpen ? "open" : "") },
                React.createElement("div", { className: "px-3 py-2" },
                    React.createElement(components_1.GKButton, { color: "link", icon: components_1.GKIconName.MenuOpen, onClick: toggle, size: "lg", className: "d-md-none" })),
                React.createElement("div", { className: "px-3" },
                    React.createElement(GKResponsiveNav_helpers_1.HomeLink, { home: home },
                        React.createElement(components_1.GKGranularLogo, { variant: components_1.GLogoVariant.LockupHorizontal, className: "w-75 mx-auto" }))),
                React.createElement("hr", null),
                getNav(models_1.Orientation.Vertical))))));
};
exports.GKResponsiveNav = GKResponsiveNav;
